<template>
   <div class="gens-vaccinetest">
       <!-- <div class="img-ss">
            <img class="gens-img" src="../../assets/images/headerimg/Header_1920x380_staysafe.jpg" />
             <h1 class="gens-title">{{$t('ContractText.Vaccine')}}</h1>
       </div> -->
       <banner>
            <img src="../../assets/images/headerimg/Header_1920x380_infectious-disease-vaccine-antibody.jpg"/>
            <div slot="title">{{$t('ContractText.Vaccine')}}</div>
        </banner>
       <div class="gens_header_tip">
           <div class="tip_red">{{$t('vaccinetest.vaccinetest_one')}}</div>
           <div class="tip_white">{{$t('vaccinetest.vaccinetest_two')}}</div>
       </div>

        <div class="gens_result">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('vaccinetest.vaccinetest_three')}}</div>
                       <div class="result_line"></div>
                   </div>
                  <div class="gens_content_first">
                      <div class="gens_content_first_left">
                          {{$t('vaccinetest.vaccinetest_four')}}
                      </div>
                      <div class="gens_content_first_right">
                          <div class="gens_content_first_right_img">
                               <img src="../../assets/images/vaccinetest/antibody_600x450.jpg" />
                          </div>
                      </div>
                  </div>
               </div>
        </div>

        <div class="gens_result_second">
               <div class="gens_result_second_info">
                   <div class="gens_result_second_info_tip">
                       <div class="gens_result_second_text">{{$t('vaccinetest.vaccinetest_five')}}</div>
                       <div class="gens_result_second_line"></div>
                   </div>
                   <div class="gens_result_second_content">
                       <div class="content_info">
                           <div class="content_info_item">
                               <div class="text_left">
                                   <div class="text_left_tip">{{$t('vaccinetest.vaccinetest_six')}}</div>
                                   <div class="text_left_content">{{$t('vaccinetest.vaccinetest_seven')}}</div>
                               </div>
                               <div class="line_down">
                                   <div class="circle"></div>
                                   <div class="vertical"></div>
                               </div>
                               <div class="img_right">
                                   <div class="img_img_right" id="img_one">
                                       <img src="../../assets/images/vaccinetest/infectious-disease_icon-01.png" />
                                   </div>
                               </div>
                           </div>
                           <div class="content_info_item" >
                                <div class="img_left">
                                   <div class="img_img_left" id="img_two">
                                       <img src="../../assets/images/vaccinetest/infectious-disease_icon-02.png" />
                                   </div>
                               </div>
                               <div class="line_down">
                                   <div class="circle"></div>
                                   <div class="vertical"></div>
                               </div>
                               <div class="text_right">
                                   <div class="text_right_tip">{{$t('vaccinetest.vaccinetest_eight')}}</div>
                                   <div class="text_right_content">{{$t('vaccinetest.vaccinetest_nine')}}</div>
                               </div>
                           </div>
                           <div class="content_info_item">
                               <div class="text_left">
                                   <div class="text_left_tip">{{$t('vaccinetest.vaccinetest_ten')}}</div>
                                   <div class="text_left_content">{{$t('vaccinetest.vaccinetest_eleven')}}</div>
                               </div>
                               <div class="line_down">
                                   <div class="circle"></div>
                                   <div class="vertical"></div>
                               </div>
                               <div class="img_right">
                                   <div class="img_img_right" id="img_three">
                                       <img src="../../assets/images/vaccinetest/infectious-disease_icon-03.png" />
                                   </div>
                               </div>
                           </div>
                           <div class="content_info_item">
                                <div class="img_left">
                                   <div class="img_img_left" id="img_four">
                                       <img src="../../assets/images/vaccinetest/infectious-disease_icon-04.png" />
                                   </div>
                               </div>
                               <div class="line_down">
                                   <div class="circle"></div>
                                   <div class="vertical"></div>
                               </div>
                               <div class="text_right">
                                   <div class="text_right_tip">{{$t('vaccinetest.vaccinetest_twelve')}}</div>
                                   <div class="text_right_content">{{$t('vaccinetest.vaccinetest_threeteen')}}</div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
        </div>
        

         <div class="gens_result">
            <div class="gens_result_info">
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('vaccinetest.vaccinetest_fourteen')}}</div>
                    <div class="result_line"></div>
                </div>
            </div>
            <div class="gens_list">
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-10.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_fiveteen')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">HAVAb, Total</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-11.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_sixteen')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">HBsAb (Quantitative)</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-12.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_seventeen')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Measles Ab IgG</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-13.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_eighteen')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Mumps Ab IgG</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-14.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_nineteen')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Rubella Ab IgG</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-15.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_twenty')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Varicella-Zoster Ab IgG</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-16.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_twenty_one')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Tetanus Toxoid IgG</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-17.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_twenty_two')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Diphtheria Toxoid IgG</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-18.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_twenty_three')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Poliovirus (Types 1, 3) Ab</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-19.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_twenty_four')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Haemophilus Influenzae Type B Ab IgG</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-20.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_twenty_five')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Streptococcus Pneumoniae IgG</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/vaccinetest/infectious-disease_icon-21.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('vaccinetest.vaccinetest_twenty_six')}}</div>
                            <div class="gens_list_item_abstract" v-if="$i18n.locale!='en-US'">Rabies Vaccine Response END-Point Titer</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="gens_result_info" >
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('vaccinetest.vaccinetest_twenty_seven')}}</div>
                    <div class="result_line"></div>
                </div>
                <div class="gens_result_info_img">
                    <img  src="../../assets/images/vaccinetest/antibody-package.png" />
                </div>
            </div>
         </div>


         <div class="gens_result special_result">
            <div class="gens_result_info">
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('vaccinetest.vaccinetest_twenty_eight')}}</div>
                    <div class="result_line"></div>
                </div>
                <div class="gens_result_science">
                       <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials" src="../../assets/images/vaccinetest/infectious-disease_icon-05.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('vaccinetest.vaccinetest_twenty_nine')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img science_item_img_one">
                               <img class="img_science img_science_specials" src="../../assets/images/vaccinetest/infectious-disease_icon-06.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('vaccinetest.vaccinetest_thirty')}}</span>
                              
                           </div>
                       </div>
                        <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img science_item_img_two">
                               <img class="img_science img_science_specials" src="../../assets/images/vaccinetest/infectious-disease_icon-07.png" alt />   
                           </div>
                           <div class="science_abstract science_item_img_three">
                               <span class="abstract_tip">{{$t('vaccinetest.vaccinetest_thirty_one')}}</span>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img science_item_img_four">
                               <img class="img_science img_science_specials" src="../../assets/images/vaccinetest/infectious-disease_icon-08.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('vaccinetest.vaccinetest_thirty_two')}}</span>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img science_item_img_five">
                               <img class="img_science img_science_specials" src="../../assets/images/vaccinetest/infectious-disease_icon-09.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('vaccinetest.vaccinetest_thirty_three')}}</span>
                           </div>
                       </div>
                       
                   </div>
            </div>
         </div>


         <div class="gens_advice">
             <div class="gens_content">
                 <div class="gens_content_left">
                     <div class="left_tips">{{$t('vaccinetest.vaccinetest_thirty_four')}}</div>
                     <div class="left_advice_content">{{$t('vaccinetest.vaccinetest_thirty_five')}}</div>
                 </div>
                 <div class="gens_content_right">
                     <div class="gens_content_img">
                         <img src="../../assets/images/vaccinetest/famplan-logo.png" alt />  
                     </div>
                 </div>
             </div>
         </div>
        
        <div class="gens_last_bottom">
            <div class="gens_last_bottom_content">
                <div class="gens_last_bottom_content_tip">{{$t('vaccinetest.vaccinetest_thirty_six')}}</div>
                <div class="gens_last_bottom_content_tip_line"></div>
                <div class="gens_last_bottom_content_descript">
                    <i class="icon iconfont iconyinhao yinhao"></i>
                    <div class="contents">
                        <div class="contents_tip">{{$t('vaccinetest.vaccinetest_thirty_seven')}}</div>
                        <div class="contents_cont">{{$t('vaccinetest.vaccinetest_thirty_eight')}}</div>
                    </div>
                </div>
                <div class="bottom_document_tip">{{$t('vaccinetest.vaccinetest_thirty_nine')}}</div>
                <div class="bottom_document_cont">1. Plotkin, Stanley A. (2009). Vaccines: the fourth century. Clin. Vaccine Immunol 16.12: 1709-1719.</div>
                <div class="bottom_document_cont bottom_document_cont_last">2. Brachman PS, Friedlander AM, Grabenstein JD. (2008). Anthrax vaccine. Vaccines, Fifth Edition, Plotkin, SA: Orenstein WA and Offit PA p111-126.</div>
            </div>
        </div>
   
   </div>
</template>
<script>
import banner from '@/components/banner'
export default {
    data(){
        return{
          
        }
    },
    components: {
      banner,
     
    },
    mounted(){
        $(window).scroll(function(){ //滚动某位置 动画特效
        console.log($(window).scrollTop());
            if($(window).scrollTop()>300){
                $('.gens_content_first_right_img').addClass('opacity');//这里840代表要动画的元素离最顶层的距离，console.log一下就知道了。
                $('.gens_content_first_right_img').addClass('rightturnleft');
            }
            if($(window).scrollTop() > 840){
                $('.img_img_right').addClass('opacity');
                $('.text_left_content').addClass('opacity');
                $('.text_right_content').addClass('opacity');
                $('.img_img_left').addClass('opacity');
                $('#img_one').addClass('rightturnleft');
                $('#img_two').addClass('two_transfer');
                $('#img_three').addClass('rightturnleft_one');
                $('#img_four').addClass('three_transfer');
                
            }
            if($(window).scrollTop() > 2900){
                $('.science_item_img').addClass('opacity');
            }
            if($(window).scrollTop() > 3342){
                $('.gens_content_img').addClass('opacity');
                $('.gens_content_img').addClass('rightturnleft');
            }
            
        })
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>

@import '../../assets/font/iconfont.css';
@import '../../assets/css/animation.css';
.gens-vaccinetest{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    .img-ss{
        position: relative;
        // display: flex;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                   top:0;
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: 600;
            }
    }
    .gens_header_tip{
        background-color: #5ec3b5;
        padding-top:30px;
        padding-bottom:30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip_red{
            text-align: center;
            color: #15867d;
            text-shadow: 1px 1px 2px #ffffff;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            text-transform: none;
            line-height: 1.384615384615385em;
        }
        .tip_white{
            text-align: center;
            color: #ffffff;
            text-shadow: 1px 1px 2px #15867d;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            text-transform: none;
            margin-top:24px;
            line-height: 1.571428571428571em;
        }
    }

    .gens_result{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_info{
             width:1200px;
             margin:auto;
             .gens_result_info_tip{
                 .result_text{
                    color: #5ec3b5;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .result_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #5ec3b5;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .result_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
                 .tip_img{
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        .tip_img_s{
                            height: auto;
                            max-width: 100%;
                            width: 300px;
                        }
                 }
                 .tip_text_sk{
                     color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom:30px;
                 }
             }
             
             .gens_content_first{
                
                 display: flex;
                 justify-content: flex-start;
                 flex-direction: row;
                 margin-bottom:30px;
                 .gens_content_first_left{
                        width:66.66%;
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        margin-bottom:30px;
                        margin-right: 30px;
                 }
                 .gens_content_first_right{
                     width:27.33%;
                     .gens_content_first_right_img{
                         opacity: 0;
                         margin-top:-60px;
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                         img{
                             height: auto;
                             max-width: 100%;
                             width:600px;
                         }
                     }
                     
                 }
             }

            .gens_result_info_img{
                margin-bottom:30px;
                display: inline-block;
                vertical-align: top;
                max-width: 100%;
                img{
                    vertical-align: middle;
                    height: auto;
                    max-width: 100%;
                }
            }

            .gens_result_science{
                  display:flex;
                  justify-content: left;
                  flex-direction: row;
                  width: 70%;
                  min-width: 900px;
                  padding-bottom:30px;
                 .science_item{
                    width:14.66%;
                    text-align: center;
                    .science_item_img{
                        display: grid;
                        justify-content: center;
                        width: 100%;
                        position: relative;

                        -webkit-transition: opacity .8s ease 0s;
                        opacity: 0;
                        transition-delay: .4s;
                        .img_science{
                            display: block;
                            margin: 0 0 15px ;
                            max-width: 100%;
                            height: auto;
                        }
                        .img_science_special{
                            width:150px !important;
                        }
                        
                    }
                    .science_item_img_one{
                        transition-delay: .2s;
                    }
                    .science_item_img_two{
                        transition-delay: .4s;
                    }
                    .science_item_img_three{
                        transition-delay: .6s;
                    }
                    .science_item_img_four{
                        transition-delay: .8s;
                    }

                    hr{
                            color: #9a9a9a;
                            display: block;
                            unicode-bidi: isolate;
                            margin-block-start: 0.5em;
                            margin-block-end: 0.5em;
                            margin-inline-start: auto;
                            margin-inline-end: auto;
                            overflow: hidden;
                            border-style: inset;
                            border-width: 1px;
                            border-top: 1px solid #9a9a9a !important;
                        }
                    .science_tip{
                        color: #ef682f;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 1.304347826086957em;
                        text-transform: none;
                        letter-spacing: 1px;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                    }
                    .science_abstract{
                         margin: 16px 0px 6px 0px;
                        .abstract_tip{
                           
                            font-size:16px;
                        }
                        .number{
                            font-size: .5em;
                            vertical-align: super;
                        }
                    }

                 }
                 .science_item_special{
                    padding-left: 15px;
                    padding-right: 15px;
                }
                .science_item_special_std{
                    width:33.33% !important;
                    .img_science_specials{
                            width:220px !important;
                    }
                }
             }
             

         }

         .gens_list{

             display:flex;
             width:1200px;
             margin:auto;
             justify-content: space-between;
             text-align: left;
             flex-direction: row;
             flex-wrap: wrap;
             margin-bottom:30px;
             .gens_list_item{
                 width:22%;
                 display: flex;
                 flex-direction: column;
                 .gens_list_item_single{
                     display:flex;
                     flex-direction: row;
                     margin-bottom:18px;
                    .gens_list_item_img{
                        display: inline-block;
                        position: relative;
                        z-index: 2;
                        img{
                            
                            height: auto;
                            width:52px;
                        }
                    }
                    .gens_list_item_content{
                        padding: 0 0 0 20px;
                        .gens_list_item_tip{
                            color: #15867d;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            line-height: 1.571428571428571em;
                                                    
                            letter-spacing: 1px;
                        }
                        .gens_list_item_abstract{
                            font-size: 14px;
                            line-height: 24px;
                            color: #3a3a3a;
                            font-style: normal;
                            font-weight: 400;
                        }
                    }
                 }
             }
         }
         
    }

    .gens_result_second{
         background-color: rgba(192,227,221,0.2);
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_second_info{
             width:1200px;
             margin:auto;
             .gens_result_second_info_tip{
                 .gens_result_second_text{
                    color: #5ec3b5;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_result_second_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #5ec3b5;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .gens_result_second_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
               
             }

             .gens_result_second_content{
                 text-align: center;
                 .content_info{
                     display:flex;
                     justify-content: center;
                     align-items: center;
                     flex-direction: column;
                     .content_info_item{
                         width:1200px;
                         display: flex;
                         justify-content: center;
                         flex-direction: row;
                         .text_left{
                             padding:0 60px;
                             width:50%;
                             .text_left_tip{
                                color: #15867d;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: right;
                             }
                             .text_left_content{
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                opacity: 0;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: right;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }
                         .line_down{
                             display:flex;
                             flex-direction: column;
                             justify-content: center;
                             width: 20px;
                             padding-top:60px;
                             position: relative;
                             .circle{
                                 position:absolute;
                                background: #fff;
                                background-color: #5ec3b5;
                                box-sizing: border-box;
                                border: 1px solid transparent;
                                border-radius: 50%;
                                content: "";
                                height: 18px;
                                left: 50%;
                                margin: 0 0 0 -9px;
                                position: absolute;
                                top:20px;
                                width: 18px;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.68) .5s;

                             }
                             .vertical{
                                background-color: #5ec3b5;
                                height: 100%;
                                left: 50%;
                                margin-left: -1px;
                                position: absolute;
                                width: 2px;
                             }
                         }
                         .img_right{
                             width:50%;
                             margin-left:-10px;
                             display:flex;
                             align-items: center;
                             padding-top:20px;
                             .img_img_right{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: left;
                                box-sizing: border-box;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width: 1522px;
                                }
                             }
                             
                         }
                         .img_left{
                             width:50%;
                             margin-left:10px;
                             display:flex;
                             align-items: center;
                             padding-top:20px;
                             .img_img_left{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: right;
                                box-sizing: border-box;
                                margin-right:-10px;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width: 1522px;
                                }
                             }
                         }
                           .text_right{
                             width:50%;
                             text-align: left;
                             padding:0 0px;
                             .text_right_tip{
                                color: #15867d;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: left;
                                padding-left:60px;
                             }
                            .text_right_content{
                                width:100%;
                                padding-left:60px;
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                opacity: 0;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: left;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }

                     }
                 }
             }
        }
    }
    

    .gens_advice{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
         
        .gens_content{
            width:1200px;
            margin:auto;
            display: flex;
            justify-content: left;
            flex-direction: row;

            .gens_content_left{
                width:66.66%;
                padding-right:15px;
                .left_tips{
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    color: #5ec3b5;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                    margin-bottom:24px;

                }
                .left_advice_content{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
            }
            .gens_content_right{
                width:33.33%;
                display: inline-block;
                vertical-align: top;
                max-width: 100%;
                .gens_content_img{
                    animation: fadeInRight .7s 1 ease-in-out;
                    opacity: 0;
                    img{
                        height: auto;
                        max-width: 100%;
                    }
                }
            }
        }
    }
    
    .gens_last_bottom{
        background-image: url(../../assets/images/vaccinetest/antibody-report.jpg);
        background-position: 50% 111px;
        position: static;
        padding: 0;
        background-repeat: no-repeat;
        background-color: transparent;
        background-position: center 0;
        background-attachment: fixed;
        overflow: hidden;
        .gens_last_bottom_content{
            width:1200px;
            margin:auto;
            text-align: left;

            .gens_last_bottom_content_tip{
               color: #ffffff;
               font-size: 28px;
               font-style: normal;
               font-weight: 700;
               text-transform: none;
               line-height: 1.384615384615385em;
               letter-spacing: 1px;
               margin-top:60px;
            }
            .gens_last_bottom_content_tip_line{
                margin-top: 10px;
                margin-bottom: 30px;
                background-color: #ffffff;
                width: 250px;
                height: 2px;
                position: relative;

            }
            .gens_last_bottom_content_descript{
                display:flex;
                flex-direction: row;
                border-left:4px solid #5ec3b5;
                background-color: rgba(192,227,221,0.9);
                width:72.66%;
                padding-top:24px;
                padding-bottom:24px;
                margin-bottom:30px;
                padding-right:12px;
                .yinhao{
                    color: #5ec3b5;
                    font-size: 38px;
                    margin: 6px 0 0 12px !important;
                    display: inline-block;
                    font: normal normal normal 14px/1 FontAwesome;
                    letter-spacing: 0.07em !important;
                }
                .contents{
                    margin-left:40px;
                   .contents_tip{
                        color: #15867d;
                        font-size: 21px;
                        line-height: 32px;
                        letter-spacing: 0px;
                        text-transform: none;
                        font-style: normal;
                        font-weight: 300;

                   }
                   .contents_cont{
                       color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                   }
                }
            }

            .bottom_document_tip{
                font-size: 12px;
                color: #ffffff;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
            }
            .bottom_document_cont{
                font-size: 12px;
                color: #ffffff;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
                
            }
            .bottom_document_cont_last{
                margin-bottom:60px;
            }
            
            
        }
    }


.opacity{
    opacity: 1 !important;
}

.special_result{
   background-color: rgba(192,227,221,0.2);
  
}
    
           

}
</style>

<style lang="scss">

.gens_results_right{
    .el-carousel__button{
        border-radius: 50% !important;
        width:12px !important;
        height: 12px !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/genedetection/vaccinetest.vue